import React, { Component } from 'react'
import moment from 'moment'
import Select from 'react-select'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Bar } from 'react-chartjs-2'
import { AvForm } from 'availity-reactstrap-validation'
import { voyagePerTrayek } from 'actions/dashboardAction'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { Card, CardBody, CardHeader, Row, Col, FormGroup, Button } from 'reactstrap'

let isDefaultTahun = false
let tahun = moment().format('Y')

class VoyagePerTrayek extends Component {
  constructor(props) {
    super(props)
    this.state = {
      getYear: false,
      tahun: '',
    }

    this.selectTahun = this.selectTahun.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
  }

  componentDidMount() {
    let data = {
      tahun: tahun
    }

    this.props.voyagePerTrayek(data)
    this.setState({ getYear: true })
  }

  componentWillUnmount() {
    isDefaultTahun = false
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.voyagePerTrayekIsSuccess) {
      if (this.state.getYear) {
        this.setState({
          getProvinsi: false,
        })

        let pushData = {
          label: 'Semua',
          value: 'ALL',
          tahun: '',
        }

        nextProps.voyagePerTrayekData.tahun.splice(0, 0, pushData)
      }
    }
  }

  selectTahun(opt) {
    if (opt) {
      this.setState({ tahun: opt.value })
    } else {
      this.setState({ tahun: '' })
    }
  }

  handleFilter(event, values) {
    if (this.state.tahun) {
      values.tahun = this.state.tahun
      isDefaultTahun = true
    } else {
      values.tahun = tahun
      isDefaultTahun = false
    }

    this.props.voyagePerTrayek(values)
  }

  render() {
    if (this.props.voyagePerTrayekIsLoading) {
      return (
        <div>
          <p>Loading ..... </p>
        </div>
      )
    }

    if (this.props.voyagePerTrayekHasError) {
      return (
        <div>
          <p>Silahkan mencoba beberapa saat lagi, pastikan anda terkoneksi dengan internet</p>
        </div>
      )
    }

    return (
      <div>
        {this.renderData()}
      </div>
    )
  }

  renderData() {
    if (this.props.voyagePerTrayekIsSuccess) {
      const defaultValues = {
        tahun: this.state.tahun
      }

      const { tahun } = this.state.tahun
      const defaultValueTahun = { label: defaultValues.tahun, value: defaultValues.tahun }

      let voyagePerTrayekData = this.props.voyagePerTrayekData.report
      let labels = []
      let data = []

      voyagePerTrayekData.forEach(val => {
        let arrLabel = val.kode
        let arrData = val.voyage

        labels.push(arrLabel)
        data.push(arrData)
      })

      const _buildColor = function (arr) {
        let dataValue = Object.values(arr)
        let resColor = []

        dataValue.map(() => (
          resColor.push('#' + (Math.random() * 0xFFFFFF << 0).toString(16))
        ))

        return resColor
      }

      const bar_voyage = {
        labels: labels,
        datasets: [
          {
            backgroundColor: _buildColor(labels),
            data: data,
          },
        ],
      }

      const options_voyage = {
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        },
        tooltips: {
          enabled: false,
          custom: CustomTooltips
        },
        legend: {
          display: false,
        },
        maintainAspectRatio: false
      }

      return (
        <div>
          <Card>
            <CardHeader>
              <h5 className="text-center">Total Voyage Per Trayek Periode</h5>
              <hr />
              <AvForm onValidSubmit={this.handleFilter} model={defaultValues}>
                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Select name="tahun"
                        value={tahun}
                        isClearable
                        placeholder="Tahun..."
                        defaultValue={isDefaultTahun ? defaultValueTahun : false}
                        onChange={this.selectTahun}
                        options={this.props.voyagePerTrayekData.tahun}
                        id="tahun"
                        inputId="input_tahun"
                        instanceId="instance_tahun"
                      />
                    </FormGroup>
                  </Col>
                  <Col md="6" className="align-self-end">
                    <FormGroup className="form-actions">
                      <Button type="submit" size="md" color="primary" className=" btn-brand mr-1 mb-1">
                        <i className="fa fa-search"></i> <span>Proses </span>
                      </Button>
                    </FormGroup>
                  </Col>
                </Row>
              </AvForm>
            </CardHeader>
            <CardBody>
              <div className="chart-wrapper">
                <Bar data={bar_voyage} options={options_voyage} height={100} />
              </div>
            </CardBody>
          </Card>
        </div>
      )
    }
  }
}

VoyagePerTrayek.propTypes = {
  voyagePerTrayekIsSuccess: PropTypes.bool.isRequired,
  voyagePerTrayekHasError: PropTypes.bool.isRequired,
  voyagePerTrayekIsLoading: PropTypes.bool.isRequired,
}

const mapStateToProps = (state) => {
  return {
    voyagePerTrayekData: state.dashboard.voyagePerTrayekData,
    voyagePerTrayekIsSuccess: state.dashboard.voyagePerTrayekSuccess,
    voyagePerTrayekHasError: state.dashboard.voyagePerTrayekError,
    voyagePerTrayekIsLoading: state.dashboard.voyagePerTrayekLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    voyagePerTrayek: (data) => dispatch(voyagePerTrayek(data))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VoyagePerTrayek)